import { gql } from "@apollo/client";

export const GET_GENERATE_NEW_PROTOCOL_DATA = gql`
    query GetGenerateNewProtocolData($assemblyid: uuid!) {
        file_v_generate_new_protocol(where: { assemblyid: { _eq: $assemblyid } }, limit: 1) {
            assembly_last_updated
            file_last_inserted
            generate_new_protocol
            fileid
        }
    }
`;

export const GET_SIGNATURES_FOR_PROTOCOL = gql`
    query GetSignaturesForProtocol($assemblyid: uuid!) {
        cond_signatures(where: { assemblyid: { _eq: $assemblyid } }) {
            id
            title
            text
        }
    }
`;

export const INSERT_SIGNATURES = gql`
    mutation InsertSignatures($objects: [cond_signatures_insert_input!]!) {
        insert_cond_signatures(
            objects: $objects
            on_conflict: { constraint: PK_signatures, update_columns: [title, text] }
        ) {
            returning {
                id
            }
        }
    }
`;

export const DELETE_SIGNATURE = gql`
    mutation DeleteSignature($signatureId: uuid!) {
        delete_cond_signatures(where: { id: { _eq: $signatureId } }) {
            affected_rows
        }
    }
`;

export const DELETE_SIGNATUREFILES = gql`
    mutation DeleteSignatureFiles($signatureId: uuid!) {
        delete_file_assemblysignatures(where: { signatureid: { _eq: $signatureId } }) {
            affected_rows
        }
    }
`;

export const GET_ASSEMBLY_SIGNATURE_FILES = gql`
    query GetAssemblySignatureFiles($assemblyId: uuid!, $role: Int) {
        file_v_assemblysignatures(where: { _and: [{ assemblyid: { _eq: $assemblyId } }, { roleid: { _eq: $role } }] }) {
            fileid
            mimetype
            name
            filedate
            signatureid
        }
    }
`;
